import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, Music2 } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function Footer() {
    const { t } = useLang();
    return (
        <footer data-testid="site-footer" className="border-t border-white/10 mt-24 bg-black">
            <div className="px-6 md:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
                {/* Left: About + Explore */}
                <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">
                    <div>
                        <div className="flex items-center gap-2">
                            <span className="w-2.5 h-2.5 bg-volt inline-block" />
                            <span className="font-heading text-xl tracking-wider">Elite Player Academy</span>
                        </div>
                        <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-sm">
                            {t("contact_body")}
                        </p>
                    </div>
                    <div>
                        <div className="font-heading text-volt tracking-widest text-sm">
                            {t("explore").toUpperCase()}
                        </div>
                        <ul className="mt-4 space-y-2 text-sm text-white/70">
                            <li><Link to="/" className="hover:text-volt">{t("nav_home")}</Link></li>
                            <li><Link to="/programs" className="hover:text-volt">{t("nav_programs")}</Link></li>
                            <li><Link to="/trainings" className="hover:text-volt">{t("nav_trainings")}</Link></li>
                            <li><Link to="/reviews" className="hover:text-volt">{t("nav_reviews")}</Link></li>
                            <li><Link to="/contact" className="hover:text-volt">{t("nav_contact")}</Link></li>
                        </ul>
                    </div>
                </div>
                {/* Right: Logo + Socials */}
                <div className="flex flex-col items-start md:items-end gap-6">
                    <img src="/site_assets/logo.png" alt="Elite Player Academy" className="w-24 h-24 object-contain" />
                    <div className="flex items-center gap-2 flex-wrap">
                        {[
                            { Icon: Instagram, href: "https://www.instagram.com/elite_player_academy", label: "instagram" },
                            { Icon: Youtube, href: "https://youtube.com/@eliteplayeracademy", label: "youtube" },
                            { Icon: Music2, href: "https://www.tiktok.com/@elite_player_academy", label: "tiktok" },
                            { Icon: Mail, href: "mailto:eliteplayeracademy1@gmail.com", label: "email" },
                        ].map(({ Icon, href, label }) => (
                            <a key={label} href={href} target="_blank" rel="noreferrer"
                               aria-label={label} data-testid={`footer-social-${label}`}
                               className="w-10 h-10 border border-white/20 hover:border-volt hover:text-volt flex items-center justify-center transition-colors">
                                <Icon size={16} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10 px-6 md:px-12 lg:px-20 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
                <div>© {new Date().getFullYear()} Elite Player Academy · Frankfurt am Main</div>
                <div className="flex items-center gap-5">
                    <Link to="/impressum" data-testid="footer-impressum" className="hover:text-volt">
                        {t("impressum")}
                    </Link>
                    <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-volt">
                        {t("datenschutz")}
                    </Link>
                    <Link to="/cookies" data-testid="footer-cookies" className="hover:text-volt">
                        {t("cookie")}
                    </Link>
                </div>
            </div>
        </footer>
    );
}
